import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { SolicitarAyuda } from './pages/SolicitarAyuda';
import { QuieroSerAliado } from './pages/QuieroSerAliado';
import { Donar } from './pages/Donar';
import { VenezuelaEmergencia } from './pages/VenezuelaEmergencia';
import { DonarVenezuela } from './pages/DonarVenezuela';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="w-full min-h-screen bg-white" data-id="element-1">
        <Navbar data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/solicitar-ayuda" element={<SolicitarAyuda data-id="element-7" />} data-id="element-6" />
          <Route path="/quiero-ser-aliado" element={<QuieroSerAliado data-id="element-9" />} data-id="element-8" />
          <Route path="/donar" element={<Donar data-id="element-11" />} data-id="element-10" />
          <Route path="/venezuela-emergencia" element={<VenezuelaEmergencia data-id="element-13" />} data-id="element-12" />
          <Route path="/donar-venezuela" element={<DonarVenezuela data-id="element-15" />} data-id="element-14" />
        </Routes>
        <Footer data-id="element-16" />
      </div>
    </BrowserRouter>;
}